import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, TextField } from '@mui/material';

export default function TextInputMultiple(props) {
  const { errors, labelAbove, label, fullWidth, ...textFieldProps } = props;

  return (
    <FormControl fullWidth={(fullWidth !== undefined) ? fullWidth : true}>
      { labelAbove &&
        <InputLabel className="label-above" htmlFor={props.id}>{props.label}</InputLabel>
      }
      <TextField	
        error={!!errors}
        helperText={errors && errors.message}
        variant='outlined'
        {...textFieldProps}
        label={labelAbove ? undefined : label}
        multiline
        rows={4}
        maxRows={Infinity}
      />
    </FormControl>
  )
}

TextInputMultiple.propTypes = {
  id: PropTypes.string.isRequired,
  inputRef: PropTypes.func,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelAbove: PropTypes.bool,
  onBlur: PropTypes.func,
  errors: PropTypes.object,
  fullWidth: PropTypes.bool,
}
